// Texto da Nota Prime — camada de EXIBIÇÃO (rodada 43, 21/08/2026).
// A função do banco (calcular_nota_bko_mes) devolve pilar/detalhe/sugestão sem
// acento e com número em formato americano ("Meta do mes batida", "299626.3%",
// "6o lugar"). A régua é de outra frente e acabou de ser ajustada — texto se
// corrige AQUI, na tela, sem migration. Se um dia o banco acentuar, estas
// regras viram no-op (não casam com texto já correto).

const PALAVRAS: Array<[RegExp, string]> = [
  [/\bmes\b/g, 'mês'],
  [/\bMes\b/g, 'Mês'],
  [/\bnao\b/g, 'não'],
  [/\bNao\b/g, 'Não'],
  [/\bninguem\b/g, 'ninguém'],
  [/\bate\b/g, 'até'],
  [/\bAte\b/g, 'Até'],
  [/\bBalanca\b/g, 'Balança'],
  [/\bbalanca\b/g, 'balança'],
  [/\bRecuperacao\b/g, 'Recuperação'],
  [/\brecuperacao\b/g, 'recuperação'],
  [/\btabulacoes\b/g, 'tabulações'],
  [/\btabulacao\b/g, 'tabulação'],
  [/\bdestinatarios\b/g, 'destinatários'],
  [/\bConvergencia\b/g, 'Convergência'],
  [/\bconvergencia\b/g, 'convergência'],
  [/\bdecisao\b/g, 'decisão'],
  [/\bligacao\b/g, 'ligação'],
  [/\bligacoes\b/g, 'ligações'],
  [/\bproposito\b/g, 'propósito'],
  [/\bvoce\b/g, 'você'],
  [/\bso\b/g, 'só'],
  [/\bSo\b/g, 'Só'],
  [/\bja\b/g, 'já'],
  [/\bpendencia\b/g, 'pendência'],
  [/\bpendencias\b/g, 'pendências'],
  [/\btramitacao\b/g, 'tramitação'],
  [/\bTramitacao\b/g, 'Tramitação'],
];

// "e" → "é" não tem regra genérica segura ("por ela e por você" é conjunção).
// Só padrões inequívocos das frases da régua.
const FRASES: Array<[RegExp, string]> = [
  [/^E /, 'É '],
  [/ e o que /g, ' é o que '],
  [/Convergência e decisão/g, 'Convergência é decisão'],
  [/quem esta na frente/g, 'quem está na frente'],
];

function formatarNumeros(s: string): string {
  return s
    .replace(/(\d+)\.(\d+)%/g, (_m, int: string, dec: string) =>
      `${Number(`${int}.${dec}`).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`)
    .replace(/(?<![\d.,])(\d{4,})(?![\d.,%])/g, (m) => Number(m).toLocaleString('pt-BR'))
    .replace(/\b(\d+)o\b/g, '$1º')
    .replace(/ x (\d)/g, ' × $1')
    .replace(/KPI\(s\)/g, 'KPIs');
}

/** Corrige acentuação e formato numérico brasileiro num texto vindo da régua. */
export function corrigirTextoNota(s?: string | null): string {
  if (!s) return '';
  let out = formatarNumeros(s);
  for (const [re, sub] of PALAVRAS) out = out.replace(re, sub);
  for (const [re, sub] of FRASES) out = out.replace(re, sub);
  return out;
}

/** Nome de gente para a função — o mesmo fix do cfbad84f4 (21/08), agora num
 *  lugar só, usado pela lista e pelo modal de pilares. */
export const FUNCAO_CURTA: Record<string, string> = {
  BKO_CONTRATO: 'Contrato',
  BKO_INPUT: 'Tramitação',
  BKO_TRAMITACAO: 'Tramitação',
  BKO_PORTABILIDADE: 'Portabilidade',
  BKO_COMPLETO: 'Completo',
  ANALISTA_QUALIDADE: 'Analista Qualidade',
  ANALISTA_QUALIDADE_2: 'Analista Qualidade 2',
  ANALISTA_QUALIDADE_3: 'Analista Qualidade 3',
  SUPERVISORA_BACKOFFICE: 'Supervisão Qualidade',
  CONSULTOR_JUNIOR: 'Consultor júnior',
  CONSULTOR_PLENO: 'Consultor pleno',
  CONSULTOR_SENIOR: 'Consultor sênior',
  CONSULTOR_RETENCAO: 'Consultor retenção',
  SUPERVISORA_VENDAS: 'Supervisão comercial',
  GERENTE_COMERCIAL: 'Gerência Comercial',
};

export const funcaoCurta = (funcao?: string | null) =>
  FUNCAO_CURTA[funcao || ''] || funcao || '—';
